import {
    Component,
    OnInit,
    OnDestroy,
    Input,
    Inject,
    PLATFORM_ID,
    EventEmitter,
    HostListener,
    Injector,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    AfterViewInit
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { AppModuleShared } from "../../app.shared.module";
import { BoxQuotaData } from "../../model/box.quote.data";
import { BoxOpenModeService } from "../../services/boxOpenMode/boxOpenMode.service";
import { dragAndDropSymbol } from "../../services/dragAndDropSymbol/dragAndDropSymbol.service";
import { getPipBySymbol } from "../../interfaces/quote.data";
import { OrderOperationType, OrderEntryType } from "../modals/orderentry/orderentry.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import * as $ from "jquery";
import { GlobalGridModeService } from "../../services/globalGridMode/globalGridMode.service";
import { TradeRequestModel } from "../../model/trade.request.data";
import { DataService } from "../../services/data/data.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { SymbolTypeEnum } from "../../enums/SymbolType.enum";
import { AppComponentBase } from "../../services/AppComponentBase";
import { ShowModalOrderEntry } from "../modals/orderentry/show-order-entry-modal";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";
import { scanData } from "../scanner/model/scanData";
import { ChartLayoutModeService } from "../../services/chartLayoutMode/chartLayoutMode.service";
import { ScannerPrimarySearchList } from "../scanner/interfaces/scanner.enums";

@Component({
    selector: "app-box",
    template: require('./box.component.html'),
    styles: [require('./box.component.css')]
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoxComponent extends AppComponentBase implements OnDestroy, AfterViewInit, OnInit {
    @Input() hideBorderTop = false;
    @Input() public item!: BoxQuotaData;
    @Input() public displayMode: number = 1;
    @Input() public pip: number = 1;
    @Input() public boxIndex: number = -1;

    public _searchDataRule: any;
    @Input() public set searchDataRule(v: any) {
        try {
            if (v) {
                switch (v.scanner) {
                    case ScannerPrimarySearchList.SCANNER_WIZARD:
                        if (v.rule.side != "scanner_side_buy") this.iconDirectionUp = false;

                        break;

                    case ScannerPrimarySearchList.SCANNER_CHARTING:
                        if (v.rule.direction != "scanner_side_buy") this.iconDirectionUp = false;
                        break;

                    case ScannerPrimarySearchList.SCANNER_TIWIZARD:
                        if (v.rule.buyingselling) {
                            if (v.rule.buyingselling.from <= 0 && v.rule.buyingselling.to <= 0)
                                this.iconDirectionUp = false;
                        }

                        break;

                    case ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS:
                        this.iconDirectionUp = true;
                        break;
                }
            }
        } catch (e) {
            console.log(e);
        }
        this._searchDataRule = v;
    }

    private _iconDirectionUp: boolean = true;
    public get iconDirectionUp(): boolean {
        return this._iconDirectionUp;
    }
    public set iconDirectionUp(value: boolean) {
        this._iconDirectionUp = value;
    }
    public get searchDataRule(): any {
        return this._searchDataRule;
    }

    private _openMode: number = 0;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        injector: Injector,
        private openModeService: BoxOpenModeService,
        private dragAndDropSymbol: dragAndDropSymbol,
        private cdr: ChangeDetectorRef,
        private activeLayoutTypeService: ChartLayoutModeService
    ) {
        super(injector);
        this.openModeService.subscriber.subscribe(activeSymbol => {
            if (activeSymbol !== this.item.Symbol) {
                this.openMode = 0;
            }
        });

        if (this.displayMode == 1) {
            this.globaGridMode.volumeOpened.subscribe(activeSymbol => {
                if (activeSymbol !== this.item.Symbol) {
                    this.showTradeVolumeSubmenu = false;
                }
            });

            this.dragAndDropSymbol.subscriber.subscribe(symbol => {
                this.currentDragged = symbol;
            });
        }
    }

    ngAfterViewInit(): void {
        // this.cdr.detach();
    }

    ngOnInit(): void {
        let checkValue = this.volumes.filter(item => item.value === this.selectedVolume);

        if (this.selectedVolume > -1 && checkValue.length == 0) {
            this.showVolumeInput = true;
        }
    }

    private _currentDragged: string = "";

    set currentDragged(v: string) {
        this._currentDragged = v;
    }

    get currentDragged() {
        return this._currentDragged;
    }

    set activeBasket(v: number) {
        this.workspace.activeBasket = v;
    }

    get activeBasket() {
        return this.workspace.activeBasket;
    }

    public precision = 0;
    get Ask(): string {

        this.precision = this.item.Decimal;
        const ask = this.item.Ask.toFixed(this.precision);

        return ask
    }

    get Spread(): string {
        this.precision = this.item.Decimal;

        return this.item.Spread.toFixed(2);
    }

    get Bid(): string {
        /*if (this.displayMode == 3) {
            return this.item.Bid.toString();
        }*/
      //  console.time("GETBID");
        this.precision = this.item.Decimal;
        const bid = this.item.Bid.toFixed(this.precision);
     //   console.timeEnd("GETBID")
        return bid;
    }

    get X() {
        return (this.item.Ask - this.item.Bid) * Math.pow(10, this.item.Decimal - 1);
    }

    get openMode(): number {
        return this._openMode;
    }

    set openMode(mode: number) {
        if (this._openMode !== mode) {
            if (this._openMode === 0) {
                this._openMode = 1;
            } else {
                this._openMode = 0;
            }
            if (this._openMode === 1) {
                this.openModeService.subscriber.next(this.item.Symbol);
            }
        }
    }

    setChartsSymbol() {
        this.globaGridMode.emitSymbolChanged({ symbol: this.item.Symbol, overrideLockAllCharts: true });
    }

    dragStart(): void {
        this.dragAndDropSymbol.subscriber.next(this.item.Symbol);
        //   console.log(this.item.Symbol);
    }

    ngOnDestroy(): void {
        // this.dragAndDropSymbol.subscriber.unsubscribe();
        // this.openModeService.subscriber.unsubscribe();
    }

    precise(x: number, v: number) {
        return x.toPrecision(v);
    }

    openOrderModalSell() {
        if (this.item.Type != SymbolTypeEnum.Index) {
            ShowModalOrderEntry(
                this.item.Symbol,
                this.item.Ask,
                this.modalService,
                OrderOperationType.Sell,
                this.item.Type,
                this.workspace.mobileMode,
                undefined,
                this.workspace.newOrderLayout
            );
        }
    }
    openOrderModalBuy(scanner?: boolean) {
        if (this.item.Type != SymbolTypeEnum.Index) {
            ShowModalOrderEntry(
                this.item.Symbol,
                this.item.Bid,
                this.modalService,
                OrderOperationType.Buy,
                this.item.Type,
                this.workspace.mobileMode,
                scanner,
                this.workspace.newOrderLayout
            );
        }
    }

    protected _oneClickAllowed: boolean = true;
    public get oneClickAllowed(): boolean {
        if (this.item.Type == SymbolTypeEnum.Index) {
            // if(this.item.Type==SymbolTypeEnum.Index)
            // {
            //   this.oneClickAllowed = false;
            // }
            return false;
        }
        return this._oneClickAllowed;
    }
    public set oneClickAllowed(value: boolean) {
        this._oneClickAllowed = value;
    }

    /*display mode 1 items*/
    public get oneClickTrade(): boolean {
        return this.item.oneClickTrade;
    }
    public set oneClickTrade(v: boolean) {
        this.item.oneClickTrade = v;
    }

    public get selectedVolume(): number {
        return this.item.selectedVolume;
    }

    public set selectedVolume(v: number) {
        this.item.selectedVolume = v;
    }

    public get tradeSizeLabel(): string {
        return this.item.tradeSizeLabel;
    }

    public set tradeSizeLabel(v: string) {
        this.item.tradeSizeLabel = v;
    }

    private _showTradeVolumeSubmenu: boolean = false;

    public newSymbol() {
        this.globaGridMode.emitSymbolChanged({ symbol: this.item.Symbol, overrideLockAllCharts: false });
    }

    public newSymbolAfterScan() {
        console.log(this.searchDataRule);
        //  this
        if (this.searchDataRule.scanner == "scanner_entrysignals") {
            this.workspace.chartDisplayMode = ChartDisplayMode.ENTSIGNALS;
            this.workspace.scanresultsView = ChartDisplayMode.ENTSIGNALS;

            this.activeLayoutTypeService.subscriber.next("4");

            this.workspace.charts["ach1"].instance!.period = this.searchDataRule.rule.LData.period;
            this.workspace.charts["ach2"].instance!.period = this.searchDataRule.rule.MData.period;
            this.workspace.charts["ach3"].instance!.period = this.searchDataRule.rule.SData.period;
            this.workspace.charts["ach4"].instance!.period = this.searchDataRule.rule.EData.period;
        } else if (
            this.searchDataRule.scanner == "scanner_wizard" ||
            this.searchDataRule.scanner == "scanner_tiwizard"
        ) {
            this.workspace.chartDisplayMode = ChartDisplayMode.WIZARD;
            this.workspace.scanresultsView = ChartDisplayMode.WIZARD;

            this.activeLayoutTypeService.subscriber.next("1");
            if (this.workspace.charts["ach1"].instance != undefined) {
                this.workspace.charts["ach1"].instance.isSelected = true;
                this.workspace.charts["ach1"].instance.period = this.searchDataRule.period;
            }
        } else {
            this.workspace.chartDisplayMode = ChartDisplayMode.CHARTING;
            this.workspace.scanresultsView = ChartDisplayMode.CHARTING;

            this.activeLayoutTypeService.subscriber.next("1");
            if (this.workspace.charts["ach1"].instance != undefined) {
                this.workspace.charts["ach1"].instance.isSelected = true;
                this.workspace.charts["ach1"].instance.period = this.searchDataRule.period;
                this.workspace.charts["ach1"].instance.addScannerChartingItem(this.searchDataRule);
            }
        }

        this.globaGridMode.emitSymbolChanged({ symbol: this.item.Symbol, overrideLockAllCharts: false });

        Object.keys(this.workspace.charts).forEach(chartId => {
            //console.log(chartId, this.charts[chartId]!.instance!.period);
            if (this.workspace.charts[chartId] && this.workspace.charts[chartId].instance) {
                this.workspace.charts[chartId]!.instance!.hardRefreshPeriod();
            }
            //   this.charts[chartId]!.instance!.saveUserIndicators();
        });

        this.workspace.showScannerPage = false;
        this.workspace.showLandingPage = false;
        this.workspace.showAppStore = false;

        this.workspace.activeSymbolType = this.searchDataRule.market;
        this.symbolTypeService.scanResultClick.next(this.searchDataRule);
    }

    actionSell() {
        if (this.oneClickTrade) {
            this.tradeData.Currency = this.item.Symbol;
            this.tradeData.Side = "Sell";
            this.tradeData.Quantity = this.selectedVolume;
            this.tradeData.Type = "Market";
            this.tradeData.LimitPrice = 0;
            this.tradeData.StopPrice = 0;
            this.placeOrder();
        } else {
            this.openOrderModalSell();
        }
    }

    actionBuy() {
        if (this.oneClickTrade) {
            this.tradeData.Currency = this.item.Symbol;
            this.tradeData.Side = "Buy";
            this.tradeData.Quantity = this.selectedVolume;
            this.tradeData.Type = "Market";
            this.tradeData.LimitPrice = 0;
            this.tradeData.StopPrice = 0;
            this.placeOrder();
        } else {
            this.openOrderModalBuy();
        }
    }

    private _tradeData: TradeRequestModel = new TradeRequestModel();

    set tradeData(v: TradeRequestModel) {
        this._tradeData = v;
    }

    get tradeData(): TradeRequestModel {
        return this._tradeData;
    }

    private _currentRequestId: string = "";

    placeOrder() {
        this._currentRequestId =
            "_TRADE_" +
            this.tradeData.Type +
            this.tradeData.Side +
            this.tradeData.Currency +
            Date.now().toString() +
            "@@ONECLICK";

        this.tradeData.Id = this._currentRequestId;
        this.dataService.sendRequest({ Cmd: DataService.TYPE_TRADE, Data: this.tradeData });
    }

    onChange(e: any) {}

    public showVolumeInput = false;
    setTradeVolume(v: number, l: string, e: any) {
        if (v != -1) {
            this.selectedVolume = v;
            this.tradeSizeLabel = l;
            this.showVolumeInput = false;
        } else {
            this.showVolumeInput = true;
        }
        e.stopPropagation();
        this.showTradeVolumeSubmenu = false;
    }

    get showTradeVolumeSubmenu(): boolean {
        return this._showTradeVolumeSubmenu;
    }

    set showTradeVolumeSubmenu(v: boolean) {
        this._showTradeVolumeSubmenu = v;
        if (this._showTradeVolumeSubmenu == true) {
            this.globaGridMode.volumeOpened.next(this.item.Symbol);
        }

        /*
        if ( this._openMode !== mode ) {
            if ( this._openMode === 0 ) {
                this._openMode = 1;
            } else {
                this._openMode = 0;
            }
            if ( this._openMode === 1 ) {
                this.openModeService.subscriber.next( this.item.Symbol );
            }
        }
        */
    }

    public removeSymbolFromBasket() {
        this.workspace.removeFromBasket(this.activeBasket, this.item.Symbol);
    }

    /*
    @HostListener('document:click', ['$event'])
    documentClick(event: MouseEvent) {
      //  if(this.showTradeVolumeSubmenu==true)
   //     {
            if((<Element>event.target).className!="tradeVolumeOpener")
            {
                this.showTradeVolumeSubmenu=false;
            }
          //  this.showTradeVolumeSubmenu=false;
    //    }
       // console.log("CLICKANYWHERE");
    }
*/

    volumes = [
        // {label: '1', value:1},
        // {label: '10', value:10},
        // {label: '100', value:100},
        { label: "Trade size: 1k", value: 1000 },
        { label: "Trade size: 10k", value: 10000 },
        { label: "Trade size: 100k", value: 100000 },
        { label: "[+] Enter", value: -1 }
    ];

    private _dragOver: boolean = false;
    public set dragOver(v: boolean) {
        this._dragOver = v;
    }

    public get dragOver() {
        return this._dragOver;
    }

    public allowDrop(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.dragOver = true;
    }

    public symbolDrop(event: Event) {
        this.dragOver = false;
        event.stopPropagation();
        event.preventDefault();

        if (this.activeBasket > -1) {
            let Basket = this.workspace.getActiveBasketItems();
            let draggedIndex: number = Basket.indexOf(this.currentDragged);
            let droppedIndex: number = Basket.indexOf(this.item.Symbol);
            var oldBasket = this.workspace.getActiveBasketItems();
            var newBasket = array_move(oldBasket, draggedIndex, droppedIndex);
            this.workspace.updateBasket(this.activeBasket, newBasket);
        }
    }

    public leaveDrop(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        this.dragOver = false;
    }
}

export function array_move(arr: any, old_index: any, new_index: any) {
    new_index = ((new_index % arr.length) + arr.length) % arr.length;
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
}
